import React from 'react';

const StatsSection = () => {
  return (
    <section style={{ background: '#0D1929', position: 'relative', overflow: 'hidden', padding: '80px 0 100px' }}>
      {/* Background photo — full bleed, very faded */}
      <div style={{ position: 'absolute', inset: 0 }}>
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_17f6cb4aa-1772187879125.png"
          alt="Norwegian coastal highway at sunset with dramatic orange sky reflecting on fjord water"
          style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.07, filter: 'grayscale(100%) contrast(1.2)' }}
        />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, #0D1929 0%, rgba(13,25,41,0.85) 100%)' }} />
      </div>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 5%', position: 'relative', zIndex: 1 }}>

        {/* Section label — rotated stamp */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '60px' }}>
          <div style={{
            border: '2px solid rgba(59,111,212,0.4)',
            padding: '4px 14px',
            transform: 'rotate(-1deg)',
            fontFamily: 'monospace', fontSize: '0.6rem',
            letterSpacing: '0.25em', color: 'rgba(59,111,212,0.7)',
            textTransform: 'uppercase'
          }}>03 — Tall & fakta</div>
          <div style={{ flex: 1, height: '1px', background: 'rgba(59,111,212,0.15)', maxWidth: '80px' }} />
        </div>

        {/* Headline — mixed typefaces */}
        <div style={{ marginBottom: '70px' }}>
          <div style={{
            fontFamily: 'Georgia, serif', fontStyle: 'italic',
            fontSize: 'clamp(1rem, 1.5vw, 1.2rem)',
            color: 'rgba(138,149,163,0.6)', marginBottom: '8px'
          }}>Tallene snakker for seg selv —</div>
          <h2 style={{
            fontFamily: '"Arial Black", Impact, sans-serif',
            fontSize: 'clamp(2.5rem, 5.5vw, 5rem)',
            fontWeight: 900, color: '#EEF0F2',
            letterSpacing: '-0.04em', lineHeight: 0.9,
            textTransform: 'uppercase', margin: 0
          }}>NORGES MEST<br /><span style={{ color: '#3B6FD4' }}>BRUKTE</span> VEIHJELP</h2>
        </div>

        {/* Stats — responsive grid */}
        <div style={{ position: 'relative' }}>

          {/* Row 1 */}
          <div className="stats-row-1" style={{ display: 'grid', gridTemplateColumns: '1.8fr 1fr 1fr', gap: '2px', marginBottom: '2px' }}>

            {/* Big hero stat */}
            <div style={{
              background: '#3B6FD4',
              padding: '52px 48px',
              position: 'relative', overflow: 'hidden'
            }}>
              {/* Ghost number behind */}
              <div style={{
                position: 'absolute', right: '-20px', bottom: '-20px',
                fontFamily: '"Arial Black", sans-serif',
                fontSize: '12rem', fontWeight: 900,
                color: 'rgba(255,255,255,0.06)',
                letterSpacing: '-0.08em', lineHeight: 1,
                pointerEvents: 'none'
              }}>47K</div>

              <div style={{ position: 'relative', zIndex: 1 }}>
                <div style={{
                  fontFamily: '"Arial Black", Impact, sans-serif',
                  fontSize: 'clamp(3.5rem, 7vw, 6.5rem)',
                  fontWeight: 900, color: '#EEF0F2',
                  letterSpacing: '-0.06em', lineHeight: 0.85,
                  marginBottom: '16px'
                }}>47 000</div>
                <div style={{
                  fontFamily: '"Arial Black", sans-serif',
                  fontSize: '1.1rem', fontWeight: 900,
                  color: 'rgba(238,240,242,0.9)',
                  letterSpacing: '-0.01em', textTransform: 'uppercase',
                  marginBottom: '10px'
                }}>AKTIVE BRUKERE</div>
                <p style={{
                  fontFamily: 'Georgia, serif', fontStyle: 'italic',
                  fontSize: '0.9rem', color: 'rgba(238,240,242,0.6)',
                  lineHeight: 1.65, margin: 0, maxWidth: '280px'
                }}>Norske sjåfører stoler på NordPass hver dag for å navigere landets veier trygt og effektivt.</p>
              </div>
            </div>

            {/* Stat 2 */}
            <div style={{ background: '#161B24', padding: '40px 32px', borderTop: '3px solid #2EC4A0', position: 'relative' }}>
              <div style={{
                fontFamily: '"Arial Black", Impact, sans-serif',
                fontSize: 'clamp(2.2rem, 4vw, 3.8rem)',
                fontWeight: 900, color: '#2EC4A0',
                letterSpacing: '-0.05em', lineHeight: 0.9, marginBottom: '12px'
              }}>2 847</div>
              <div style={{
                fontFamily: 'Georgia, serif', fontStyle: 'italic',
                fontSize: '0.875rem', color: 'rgba(138,149,163,0.8)', lineHeight: 1.5
              }}>Bomstasjoner kartlagt i hele Norge</div>
              {/* Annotation */}
              <div style={{
                position: 'absolute', top: '12px', right: '12px',
                fontFamily: 'monospace', fontSize: '0.5rem',
                color: 'rgba(46,196,160,0.4)', letterSpacing: '0.1em'
              }}>↑ 2024</div>
            </div>

            {/* Stat 3 */}
            <div style={{ background: '#161B24', padding: '40px 32px', borderTop: '3px solid #E8941A', position: 'relative' }}>
              <div style={{
                fontFamily: '"Arial Black", Impact, sans-serif',
                fontSize: 'clamp(2.2rem, 4vw, 3.8rem)',
                fontWeight: 900, color: '#E8941A',
                letterSpacing: '-0.05em', lineHeight: 0.9, marginBottom: '12px'
              }}>99.8%</div>
              <div style={{
                fontFamily: 'Georgia, serif', fontStyle: 'italic',
                fontSize: '0.875rem', color: 'rgba(138,149,163,0.8)', lineHeight: 1.5
              }}>Systemoppetid siste 12 måneder</div>
            </div>
          </div>

          {/* Row 2 */}
          <div className="stats-row-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1.8fr', gap: '2px' }}>

            {/* Stat 4 */}
            <div style={{ background: '#1A2E52', padding: '40px 32px', borderBottom: '3px solid #6B5CE7', position: 'relative' }}>
              <div style={{
                fontFamily: '"Arial Black", Impact, sans-serif',
                fontSize: 'clamp(2.2rem, 4vw, 3.8rem)',
                fontWeight: 900, color: '#EEF0F2',
                letterSpacing: '-0.05em', lineHeight: 0.9, marginBottom: '12px'
              }}>4.9 ★</div>
              <div style={{
                fontFamily: 'Georgia, serif', fontStyle: 'italic',
                fontSize: '0.875rem', color: 'rgba(138,149,163,0.8)', lineHeight: 1.5
              }}>Gjennomsnittlig brukervurdering</div>
            </div>

            {/* Stat 5 */}
            <div style={{ background: '#161B24', padding: '40px 32px', borderBottom: '3px solid #3B6FD4', position: 'relative' }}>
              <div style={{
                fontFamily: '"Arial Black", Impact, sans-serif',
                fontSize: 'clamp(2.2rem, 4vw, 3.8rem)',
                fontWeight: 900, color: '#6B5CE7',
                letterSpacing: '-0.05em', lineHeight: 0.9, marginBottom: '12px'
              }}>&lt; 2 min</div>
              <div style={{
                fontFamily: 'Georgia, serif', fontStyle: 'italic',
                fontSize: '0.875rem', color: 'rgba(138,149,163,0.8)', lineHeight: 1.5
              }}>Gjennomsnittlig oppdateringstid</div>
            </div>

            {/* Wide text block — editorial */}
            <div style={{
              background: '#0A0F18',
              padding: '40px 48px',
              display: 'flex', flexDirection: 'column', justifyContent: 'center',
              borderLeft: '1px solid rgba(255,255,255,0.04)'
            }}>
              <div style={{
                fontFamily: 'Georgia, serif', fontStyle: 'italic',
                fontSize: 'clamp(1rem, 1.5vw, 1.3rem)',
                color: 'rgba(238,240,242,0.5)',
                lineHeight: 1.7, marginBottom: '20px'
              }}>
                "NordPass er det eneste verktøyet jeg trenger for å planlegge lange kjøreturer i Norge."
              </div>
              <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                {['GDPR-kompatibel', 'Kryptert', 'Norsk support']?.map((badge, i) => (
                  <div key={i} style={{
                    fontFamily: 'monospace', fontSize: '0.55rem',
                    letterSpacing: '0.2em', color: 'rgba(59,111,212,0.6)',
                    textTransform: 'uppercase',
                    borderBottom: '1px solid rgba(59,111,212,0.2)',
                    paddingBottom: '2px'
                  }}>{badge}</div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 767px) {
          .stats-row-1 { grid-template-columns: 1fr !important; }
          .stats-row-2 { grid-template-columns: 1fr 1fr !important; }
          .stats-row-2 > div:last-child { grid-column: 1 / -1; }
        }
      `}</style>
    </section>
  );
};

export default StatsSection;